/**
 * First we will load all of this project's JavaScript dependencies which
 * include Vue and Vue Resource. This gives a great starting point for
 * building robust, powerful web applications using Vue and Laravel.
 */
import './bootstrap'

import router from './router.js'
import utils from './helpers/utilities'
import store from './store/index'
import VueTimers from 'vue-timers'
import { TableComponent, TableColumn } from 'vue-table-component'
import Loading from 'vue-loading-overlay'
import VuePrismEditor from 'vue-prism-editor'

require('./bootstrap')

Vue.prototype.$utils = utils
Vue.use(VueTimers)
Vue.use(Loading)
Vue.component('prism-editor', VuePrismEditor)
Vue.component('table-component', TableComponent)
Vue.component('table-column', TableColumn)

global.axios.interceptors.request.use(function (config) {
  store.commit('setLoading', true)
  return config
}, function (error) {
  store.commit('setLoading', false)
  return Promise.reject(error)
})

global.axios.interceptors.response.use(function (response) {
  store.commit('setLoading', false)
  return response
}, function (error) {
  store.commit('setLoading', false)
  return Promise.reject(error)
})

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
const app = new Vue({
  data: () => {
    return {
      loader: undefined
    }
  },
  router,
  store,
  mounted () {
    this.$utils.setSkin('lannister')
    this.$store.subscribe((mutation, state) => {
      if (state.isLoading) {
        this.showLoader()
      } else {
        this.hideLoader()
      }
    })
  },
  methods: {
    showLoader () {
      if (!this.loader) {
        this.loader = this.$loading.show({ container: null })
      }
    },
    hideLoader () {
      if (this.loader) {
        this.loader.hide()
        this.loader = undefined
      }
    }
  }
}).$mount('#app')
